import { type FunctionComponent } from 'react';
import { SvgIcon, type SvgIconProps } from './SvgIcon';

export const MemberCenterIcon: FunctionComponent<SvgIconProps> = (props) => {
  return (
    <SvgIcon fill="none" height="26" viewBox="0 0 26 26" width="26" {...props}>
      <path
        d="M21.7784 11.75H14.7216C14.3745 11.75 14.0537 11.9406 13.8802 12.25C13.7066 12.5593 13.7066 12.9407 13.8802 13.25C14.0537 13.5594 14.3745 13.75 14.7216 13.75H21.7784C22.1255 13.75 22.4463 13.5594 22.6198 13.25C22.7934 12.9407 22.7934 12.5593 22.6198 12.25C22.4463 11.9406 22.1256 11.75 21.7784 11.75Z"
        fill="white"
      />
      <path
        d="M14.822 9.75H18.6779C19.061 9.75 19.4148 9.5593 19.6063 9.25C19.7979 8.9406 19.7979 8.5594 19.6063 8.25C19.4148 7.9406 19.061 7.75 18.6779 7.75H14.822C14.4391 7.75 14.0851 7.9406 13.8936 8.25C13.7021 8.5593 13.7021 8.9406 13.8936 9.25C14.0851 9.5594 14.4391 9.75 14.822 9.75Z"
        fill="white"
      />
      <path
        d="M9.75 10.2501C9.75 11.6308 8.6308 12.75 7.2501 12.75C5.8693 12.75 4.75 11.6308 4.75 10.2501C4.75 8.8694 5.8693 7.75 7.2501 7.75C8.6308 7.75 9.75 8.8693 9.75 10.2501Z"
        fill="white"
      />
      <path
        d="M7.2376 13.7522C6.3258 13.7294 5.4255 13.9658 4.63447 14.4357C3.84335 14.9056 3.19158 15.5909 2.75 16.4174V17.75H11.75V16.4174C11.3066 15.587 10.6509 14.899 9.8549 14.429C9.0591 13.9588 8.1535 13.7247 7.2376 13.7522Z"
        fill="white"
      />
      <path
        d="M21.7784 15.75H14.7216C14.3745 15.75 14.0537 15.9406 13.8802 16.25C13.7066 16.5594 13.7066 16.9406 13.8802 17.25C14.0537 17.5594 14.3745 17.75 14.7216 17.75H21.7784C22.1255 17.75 22.4463 17.5594 22.6198 17.25C22.7934 16.9406 22.7934 16.5594 22.6198 16.25C22.4463 15.9406 22.1256 15.75 21.7784 15.75Z"
        fill="white"
      />
      <path
        d="M21.3654 0.75H4.13462C2.26534 0.75 0.75 2.26534 0.75 4.13462V21.3654C0.75 23.2347 2.26534 24.75 4.13462 24.75H21.3654C23.2347 24.75 24.75 23.2347 24.75 21.3654V4.13462C24.75 2.26534 23.2347 0.75 21.3654 0.75Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </SvgIcon>
  );
};
